import {RightsHolderNameSettingsComponent} from '../../analysis/holder-names/rights-holder-name-settings.component';
import {Component, CUSTOM_ELEMENTS_SCHEMA, effect, input} from '@angular/core';
import {ExtendedModule, FlexModule} from "@ngbracket/ngx-layout";
import {MatButton} from "@angular/material/button";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatToolbar} from "@angular/material/toolbar";
import {RouterLink} from "@angular/router";
import {NGXLogger} from "ngx-logger";
import {NotificationService} from "../../domain/notification/notification.service";
import {LoginDialogService} from "../../shared/dialog/login-dialog/login-dialog.service";
import {SessionStorageService} from "../../_service/session-storage.service";
import {UserService} from "../../domain/user/service/user.service";
import {NativeService} from "../../_service/native.service";
import {environment} from "../../../environments/environment";
import {defineElement} from "lord-icon-element";
import lottie from "lottie-web";
import {MatDialog} from "@angular/material/dialog";
import {AutoBillingDialogComponent} from "../../shared/dialog/auto-billing/auto-billing-dialog.component";
import {NoticeService} from "../../domain/notice/notice.service";
import {CouponService} from "../../domain/coupon/coupon.service";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    ExtendedModule,
    FlexModule,
    MatButton,
    MatMenu,
    MatMenuItem,
    MatToolbar,
    RouterLink,
    MatMenuTrigger
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  providers: [NoticeService, CouponService]
})
export class HeaderComponent {
  openRightsHolderNames() { this.matDialog.open(RightsHolderNameSettingsComponent, {width: '600px', maxWidth: '95vw', maxHeight: '90vh'}); }

  mobile = input<boolean>(true);
  login = input<boolean>(false);
  seamless = input<boolean>(false);
  countNotifications: number | undefined = undefined;
  countCoupons: number | undefined = undefined;
  countNotices: number | undefined = undefined;
  countUpdates: number | undefined = undefined;
  devMode = !environment.production;

  constructor(private readonly log: NGXLogger,
              private readonly noticeService: NoticeService,
              private readonly notificationService: NotificationService,
              private readonly couponService: CouponService,
              private readonly loginDialogService: LoginDialogService,
              private readonly sessionStorage: SessionStorageService,
              private readonly userService: UserService,
              private readonly nativeService: NativeService,
              private readonly matDialog: MatDialog) {
    defineElement(lottie.loadAnimation);
    this.getMainNotices();

    this.notificationService.changeCount()
      .subscribe(count => {
        this.countNotifications = count || undefined;
      });

    effect(() => {
      if (!this.login()) {
        this.countCoupons = undefined;
        return;
      }

      this.couponService.getCoupons('ALL', true)
        .subscribe(coupons => {
          const count = Object.values(coupons ?? {})
            .reduce((total: number, value) => total + (Number(value) || 0), 0);
          this.countCoupons = count || undefined;
        });
    });
  }

  clickLogin() {
    this.loginDialogService.openLoginDialog();
  }

  clickLogout() {
    this.userService.logout();
    this.sessionStorage.clear();
    this.nativeService.forgetMe();
  }

  clickAutoBilling() {
    this.matDialog.open(AutoBillingDialogComponent)
  }

  private getMainNotices() {
    this.noticeService.getMainPageNotice(true)
      .subscribe((response: any[]) => {
        if (response) {
          this.countNotices = response.filter(notice => notice.type === 'NOTICE').length;
          this.countUpdates = response.filter(notice => notice.type === 'UPDATE').length;
        }
      });
  }
}
